<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <!-- {{ roles }} -->
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar :background-color="sidebarBackground" :short-title="$t('sidebar.shortTitle')" :title="$t('sidebar.title')">
      <!-- eslint-disable-next-line vue/no-unused-vars -->
      <template slot="links" slot-scope="props">
        <sidebar-item
          v-show="emisor_id"
          :link="{
            name: $t('sidebar.dashboard'),
            icon: 'tim-icons icon-chart-pie-36',
            path: '/dashboard'
          }">
        </sidebar-item>

        <sidebar-item
          v-show="emisor_id && showModule('ACCOUNTING')"
          :link="{ name: 'Contabilidad', icon: 'tim-icons icon-bulb-63', path: '/open/contabilidad' }">
        </sidebar-item>

        <sidebar-item v-show="emisor_id && hasShortcuts" :link="{ name: 'Mi Menú', icon: 'tim-icons icon-attach-87' }">
          <sidebar-item v-for="shortcut in shortcuts" :key="shortcut.key" :link="{ name: shortcut.path, path: shortcut.path }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-show="showMainMenu('ADMINISTRACION')" :link="{ name: 'Admin', icon: 'tim-icons icon-bank' }">
          <sidebar-item v-show="showMenu('/admin/datosatv')" :link="{ name: 'Configuración', path: '/admin/datosatv' }"></sidebar-item>
          <sidebar-item v-show="emisor_id && showMenu('/admin/roles')" :link="{ name: 'Roles', path: '/admin/roles' }"></sidebar-item>
          <sidebar-item v-show="emisor_id && showMenu('/admin/usuarios')" :link="{ name: 'Usuarios', path: '/admin/usuarios' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item v-show="emisor_id && showMainMenu('FACTURACION')" :link="{ name: 'Facturación', icon: 'tim-icons icon-money-coins' }">
          <sidebar-item v-show="showMenu('/facturacion/facturar')" :link="{ name: 'Factura Electrónica', path: '/facturacion/facturar' }"></sidebar-item>
          <sidebar-item
            v-if="$session.user.profile !== 'PRO' && $session.user.profile !== 'MICRO' && $session.user.profile !== 'FULL' /*&& $session.user.subprofile*/"
            v-show="showMenu('/facturacion/mensajeReceptor')"
            :link="{ name: 'Aceptar Comprobantes', path: '/facturacion/mensajeReceptor' }"></sidebar-item>

          <sidebar-item
            v-show="showMenu('/facturacion/listaCredito') && showModule('BILLING')"
            :link="{ name: 'Mis Facturas', path: '/facturacion/listaCredito' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/facturacion/listaPagos') && showModule('BILLING')"
            :link="{ name: 'Lista Pagos', path: '/facturacion/listaPagos' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/facturacion/listaLinks') && showModule('BILLING')"
            :link="{ name: 'Links Pago', path: '/facturacion/listaLinks' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/facturacion/reporte') && showModule('BILLING')"
            :link="{ name: 'Reporte', path: '/facturacion/reporte' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Ver Documentos' }">
            <sidebar-item v-show="showMenu('/facturacion/listaFactura')" :link="{ name: 'Facturas', path: '/facturacion/listaFactura' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/facturacion/listaTiquete')" :link="{ name: 'Tiquetes', path: '/facturacion/listaTiquete' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaNotaCredito')"
              :link="{ name: 'Notas de Crédito', path: '/facturacion/listaNotaCredito' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaMensajeReceptor')"
              :link="{ name: 'Recepción', path: '/facturacion/listaMensajeReceptor' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaFacturaCompras')"
              :link="{ name: 'Compras', path: '/facturacion/listaFacturaCompras' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaFacturaExportacion')"
              :link="{ name: 'Exportación', path: '/facturacion/listaFacturaExportacion' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/facturacion/proforma')" :link="{ name: 'Proformas', path: '/facturacion/proforma' }"></sidebar-item>

            <!-- Facturas temporales (9999) y Otras facturas (99), comparten el mismo rol -->
            <sidebar-item v-show="showMenu('/facturacion/listaFacturaOtro')" :link="{ name: 'Otros', path: '/facturacion/listaFacturaOtro' }"></sidebar-item>
            <sidebar-item
              v-show="showModule('BULK') && showMenu('/facturacion/listaFacturaOtro')"
              :link="{ name: 'Temporal', path: '/facturacion/listaFacturaBulk' }"></sidebar-item>
          </sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-show="emisor_id && showMainMenu('CLIENTES')"
          :link="{
            name: 'Clientes',
            icon: 'tim-icons icon-book-bookmark'
          }">
          <sidebar-item v-show="showMenu('/clientes/dashboard') && showModule('CRM')" :link="{ name: 'Dashboard', path: '/clientes/dashboard' }"></sidebar-item>
          <sidebar-item v-show="showMenu('/clientes/lista')" :link="{ name: 'Lista de Clientes', path: '/clientes/lista' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/clientes/suscripciones') && showModule('CRM')"
            :link="{ name: 'Suscripciones', path: '/clientes/suscripciones' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/clientes/transacciones') && showModule('CRM')"
            :link="{ name: 'Transacciones', path: '/clientes/transacciones' }"></sidebar-item>
          <sidebar-item v-show="showMenu('/clientes/categorias')" :link="{ name: 'Categorías', path: '/clientes/categorias' }"></sidebar-item>
          <!-- <sidebar-item v-show="showMenu('/clientes/cron') && showModule('CRM')" :link="{ name: 'Ciclos', path: '/clientes/cron' }"></sidebar-item> -->

          <sidebar-item v-show="showModule('MARKETING')" :link="{ name: 'Marketing' }">
            <sidebar-item :link="{ name: 'Email', path: '/clientes/marketing/email' }"></sidebar-item>
            <sidebar-item :link="{ name: 'Cumple', path: '/clientes/marketing/birthday' }"></sidebar-item>
          </sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-show="emisor_id && showMainMenu('INVENTARIO')"
          :link="{
            name: 'Inventario',
            icon: 'tim-icons icon-molecule-40'
          }">
          <sidebar-item v-show="emisor_id && showModule('INVENTORY')" :link="{ name: 'Inventario Avanzado', path: '/open/inventarioAvanzado' }"></sidebar-item>

          <!-- <sidebar-item
            v-show="showMenu('/inventario/lista') && showModule('INVENTORY')"
            :link="{ name: 'Movimientos', path: '/inventario/lista' }"></sidebar-item> -->

          <sidebar-item
            v-show="showMenu('/inventario/materiaPrima') && showModule('INVENTORY')"
            :link="{ name: 'Materia Prima', path: '/inventario/materiaPrima' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Productos' }">
            <sidebar-item v-show="showMenu('/inventario/reventa')" :link="{ name: 'Reventa', path: '/inventario/reventa' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/inventario/manufacturado') && showModule('INVENTORY')"
              :link="{ name: 'Manufacturados', path: '/inventario/manufacturado' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/inventario/consumible')" :link="{ name: 'Consumibles', path: '/inventario/consumible' }"></sidebar-item>
          </sidebar-item>

          <sidebar-item v-show="showMenu('/inventario/Servicio')" :link="{ name: 'Servicios', path: '/inventario/Servicio' }"></sidebar-item>

          <sidebar-item v-show="showModule('INVENTORY')" :link="{ name: 'Control' }">
            <sidebar-item v-show="showMenu('/inventario/categoria')" :link="{ name: 'Categoria', path: '/inventario/categoria' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/inventario/descuentos')" :link="{ name: 'Descuentos', path: '/inventario/descuentos' }"></sidebar-item>
            <!-- <sidebar-item v-show="showMenu('/inventario/CostosFijos')" :link="{ name: 'Costos Fijos', path: '/inventario/costosfijos' }"></sidebar-item> -->
            <!-- <sidebar-item
              v-show="showMenu('/inventario/CostosVariables')"
              :link="{ name: 'Costos Variables', path: '/inventario/costosvariables' }"></sidebar-item> -->

            <!-- <sidebar-item v-show="showMenu('/inventario/entrada')" :link="{ name: 'Gestión de Entradas', path: '/inventario/entrada' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/inventario/merma')" :link="{ name: 'Gestión Merma', path: '/inventario/merma' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/inventario/merma')" :link="{ name: 'Lista Merma', path: '/inventario/listaMerma' }"></sidebar-item> -->
          </sidebar-item>
        </sidebar-item>

        <sidebar-item v-show="emisor_id && showMainMenu('COMPRAS')" :link="{ name: 'Compras', icon: 'tim-icons icon-cart' }">
          <sidebar-item v-show="showMenu('/compras/FacturaCompras')" :link="{ name: 'Factura Compras', path: '/compras/FacturaCompras' }"></sidebar-item>
          <sidebar-item v-show="showMenu('/compras/comprasXml')" :link="{ name: 'Factura Compras (xml)', path: '/compras/comprasXml' }"></sidebar-item>
          <sidebar-item
            v-show="showMenu('/compras/listaCredito') && showModule('BILLING')"
            :link="{ name: 'Mis Compras', path: '/compras/listaCredito' }"></sidebar-item>

          <sidebar-item
            v-show="showMenu('/compras/listaPagos') && showModule('BILLING')"
            :link="{ name: 'Lista Pagos', path: '/compras/listaPagos' }"></sidebar-item>

          <sidebar-item
            v-show="showMenu('/compras/tipos') && showModule('BILLING')"
            :link="{ name: 'Gastos y Activos', path: '/compras/tipos' }"></sidebar-item>
          <sidebar-item v-show="showMenu('/compras/Proveedores')" :link="{ name: 'Proveedores', path: '/compras/Proveedores' }"></sidebar-item>
          <sidebar-item v-show="showMenu('/compras/reporte') && showModule('BILLING')" :link="{ name: 'Reporte', path: '/compras/reporte' }"></sidebar-item>

          <sidebar-item :link="{ name: 'Ver Documentos' }">
            <sidebar-item
              v-show="showMenu('/facturacion/listaMensajeReceptor')"
              :link="{ name: 'Recepción', path: '/facturacion/listaMensajeReceptor' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaFacturaCompras')"
              :link="{ name: 'Compras', path: '/facturacion/listaFacturaCompras' }"></sidebar-item>
            <sidebar-item v-show="showMenu('/compras/listaAnulaciones')" :link="{ name: 'Anulaciones', path: '/compras/listaAnulaciones' }"></sidebar-item>
            <sidebar-item
              v-show="showMenu('/facturacion/listaMensajeReceptor')"
              :link="{ name: 'Recepción Email', path: '/compras/listaAutoEmail' }"></sidebar-item>
          </sidebar-item>
        </sidebar-item>

        <!-- CAJAS -->
        <!-- <sidebar-item class="" v-show="emisor_id && showModule('CASHREGISTER')" :link="{ name: 'Cajas', icon: 'tim-icons icon-coins' }">
          <sidebar-item class="" v-show="showMenu('/cajas/lista')" :link="{ name: 'Lista de Cajas', path: '/cajas/lista' }"></sidebar-item>
          <sidebar-item class="" v-show="showMenu('/cajas/administrar')" :link="{ name: 'Administrar', path: '/cajas/administrar' }"></sidebar-item>
          <sidebar-item class="" v-show="showMenu('/cajas/micaja')" :link="{ name: 'Mi Caja', path: '/cajas/micaja' }"></sidebar-item>
        </sidebar-item> -->

        <!-- POS -->
        <sidebar-item class="" v-show="emisor_id && showModule('RESTAURANT')" :link="{ name: 'Punto de Venta', icon: 'tim-icons icon-paper' }">
          <sidebar-item v-show="emisor_id && showModule('INVENTORY')" :link="{ name: 'Punto de Venta', path: '/open/posAvanzado' }"></sidebar-item>

          <!-- <sidebar-item class="" v-show="showMenu('/restaurante/pedidos')" :link="{ name: 'Tomar Pedidos', path: '/restaurante/pedidos' }"></sidebar-item> -->
          <!-- <sidebar-item
            class=""
            v-show="showMenu('/restaurante/listaPedidos')"
            :link="{ name: 'Lista Pedidos', path: '/restaurante/listaPedidos' }"></sidebar-item> -->
          <!-- <sidebar-item
            class=""
            v-show="showMenu('/restaurante/listaEliminados')"
            :link="{ name: 'Lista Eliminados', path: '/restaurante/listaEliminados' }"></sidebar-item> -->
          <sidebar-item class="" v-show="showMenu('/restaurante/cocina')" :link="{ name: 'Ordenes', path: '/restaurante/cocina' }"></sidebar-item>
          <!-- <sidebar-item class="" v-show="showMenu('/restaurante/facturar')" :link="{ name: 'Facturar', path: '/restaurante/facturar' }"></sidebar-item> -->
          <!-- <sidebar-item v-show="showMenu('/restaurante/lista')" :link="{ name: 'Lista de Locales', path: '/restaurante/lista' }"></sidebar-item> -->
          <!-- <sidebar-item v-show="showMenu('/restaurante/zona')" :link="{ name: 'Zonas y Mesas', path: '/restaurante/zona' }"></sidebar-item> -->
        </sidebar-item>

        <sidebar-item class="menu-space" v-show="emisor_id && showModule('PRODUCTION')" :link="{ name: 'Produccion', icon: 'tim-icons icon-notes' }">
          <sidebar-item v-show="showMenu('/produccion/producir')" :link="{ name: 'Producir', path: '/produccion/producir' }"></sidebar-item>

          <sidebar-item class="menu-space" v-show="showMenu('/produccion/ordenes')" :link="{ name: 'Ordenes', path: '/produccion/ordenes' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item
          v-if="$session.user.profile !== 'PRO' && !$session.user.subprofile"
          :link="{ name: 'Planes', path: '/pricing', icon: 'tim-icons icon-spaceship' }"></sidebar-item>
      </template>
    </side-bar>

    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div :class="[{ content: !$route.meta.hideContent }, $darkMode.get() ? 'bg-dark-svg' : 'bg-light-svg']" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <nuxt></nuxt>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!isFullScreenRoute"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

import { /* SlideYDownTransition, */ ZoomCenterTransition } from 'vue2-transitions'
import { mapGetters } from 'vuex'
import DashboardNavbar from '@/components/Layout/DashboardNavbar.vue'
import ContentFooter from '@/components/Layout/ContentFooter.vue'
// import DashboardContent from '@/components/Layout/Content.vue'
import SidebarFixedToggleButton from '@/components/Layout/SidebarFixedToggleButton.vue'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`)
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className)
    }, 100)
  }
}

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    // DashboardContent,
    // SlideYDownTransition,
    ZoomCenterTransition
  },
  data() {
    return {
      shortcuts: [],
      sidebarBackground: 'vue' // vue|blue|orange|green|red|primary
    }
  },
  computed: {
    ...mapGetters({ emisor_id: 'facturacion/emisorStore/get_Id' }),
    emisor() {
      return this.$store.state.facturacion.emisorStore.emisor
    },
    roles() {
      return this.$store.state.admin.roleStore.list
    },
    isFullScreenRoute() {
      return this.$route.path === '/maps/full-screen'
    },
    hasShortcuts() {
      return this.shortcuts.some(shortcut => shortcut.path)
    }
  },
  created() {
    const shortcut1 = localStorage.getItem('ctl+1')
    const shortcut2 = localStorage.getItem('ctl+2')
    const shortcut3 = localStorage.getItem('ctl+3')
    const shortcut4 = localStorage.getItem('ctl+4')
    const shortcut5 = localStorage.getItem('ctl+5')

    this.shortcuts = [
      { key: 'ctl+1', path: shortcut1 },
      { key: 'ctl+2', path: shortcut2 },
      { key: 'ctl+3', path: shortcut3 },
      { key: 'ctl+4', path: shortcut4 },
      { key: 'ctl+5', path: shortcut5 }
    ]
  },
  mounted() {
    // desactiva porque hace un scroll infinito en la página.
    // this.initScrollbar()

    // Sentry tags.
    this.$sentry.setTags({ emisor_id: this.emisor.id, email: this.$session.user.email, user_id: this.$session.user.id })

    this.$swNotification.init()

    this._keyListener = e => {
      if ((e.ctrlKey || e.metaKey) && e.key === '+') {
        e.preventDefault()
        this.$store.commit('ADD_ITEM')
      } else if ((e.ctrlKey || e.metaKey) && e.key === 'e') {
        e.preventDefault()
        this.$store.commit('DELETE_ITEM')
      } else if ((e.ctrlKey || e.metaKey) && e.key === 'r') {
        e.preventDefault()
        this.$store.commit('RELOAD_LIST')
      } else if (e.key === 'F8') {
        e.preventDefault()
        this.$store.commit('RELOAD_LIST')
      } else if ((e.ctrlKey || e.metaKey) && e.keyCode === 32) {
        e.preventDefault()
        this.$store.commit('SHOW_PAGE_SELECTOR', true)
      } else if (e.key === 'Escape') {
        e.preventDefault()

        this.$store.commit('SHOW_COMPONENT_ROOT_PAGE')
      } else if ((e.ctrlKey || e.metaKey) && e.key === '1') {
        e.preventDefault()

        if (shortcut1) {
          this.$router.push(shortcut1)
        } else
          this.$notify({
            type: 'info',
            message: `Tecla sin asignar.`,
            icon: 'tim-icons icon-bell-55'
          })
      } else if ((e.ctrlKey || e.metaKey) && e.key === '2') {
        e.preventDefault()
        if (shortcut2) {
          this.$router.push(shortcut2)
        } else
          this.$notify({
            type: 'info',
            message: `Tecla sin asignar.`,
            icon: 'tim-icons icon-bell-55'
          })
      } else if ((e.ctrlKey || e.metaKey) && e.key === '3') {
        e.preventDefault()
        if (shortcut3) {
          this.$router.push(shortcut3)
        } else
          this.$notify({
            type: 'info',
            message: `Tecla sin asignar.`,
            icon: 'tim-icons icon-bell-55'
          })
      } else if ((e.ctrlKey || e.metaKey) && e.key === '4') {
        e.preventDefault()
        if (shortcut4) {
          this.$router.push(shortcut4)
        } else
          this.$notify({
            type: 'info',
            message: `Tecla sin asignar.`,
            icon: 'tim-icons icon-bell-55'
          })
      } else if ((e.ctrlKey || e.metaKey) && e.key === '5') {
        e.preventDefault()
        if (shortcut5) {
          this.$router.push(shortcut5)
        } else
          this.$notify({
            type: 'info',
            message: `Tecla sin asignar.`,
            icon: 'tim-icons icon-bell-55'
          })
      }
    }
    document.addEventListener('keydown', this._keyListener.bind(this))
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    initScrollbar() {
      const docClasses = document.body.classList
      const isWindows = navigator.platform.startsWith('Win')
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar')
        initScrollbar('main-panel')
        initScrollbar('sidebar-wrapper')

        docClasses.add('perfect-scrollbar-on')
      } else {
        docClasses.add('perfect-scrollbar-off')
      }
    },
    showModule(mod) {
      if (mod === 'RESTAURANT') return this.emisor?.restaurantModule
      if (mod === 'CASHREGISTER') return this.emisor?.cashRegisterModule
      if (mod === 'PRODUCTION') return this.emisor?.productionModule
      if (mod === 'BULK') return this.emisor?.bulkBillingModule
      if (mod === 'BILLING') return this.emisor?.billingModule
      if (mod === 'CRM') return this.emisor?.crmModule
      if (mod === 'MARKETING') return this.emisor?.marketingModule
      if (mod === 'INVENTORY') return this.emisor?.inventoryModule
      if (mod === 'ACCOUNTING') return this.emisor?.accountingModule

      return false
    },
    showMainMenu(main) {
      if (this.$session.user.profile === 'PRO') return true
      if (this.$session.user.profile === 'MICRO') return true
      if (this.$session.user.profile === 'FULL') return true

      const checkRoles = this.$session?.user?.roles?.filter(role => role.check) || []

      if (this.$session.user.profile === 'COMMUNITY' || this.$session.user.profile === 'FACTURA') {
        if (main === 'ADMINISTRACION' || main === 'FACTURACION' || main === 'CLIENTES') return true

        return false
      }

      const hasRole = this.roles.reduce(
        (acc, role) =>
          checkRoles.some(r => role._id === r._id)
            ? role.events.some(event => event.name.toUpperCase() === main.toUpperCase() && event.group.some(eg => eg.check))
              ? (acc = true)
              : acc
            : acc,
        false
      )
      return hasRole
    },
    showMenu(path) {
      if (this.$session.user.profile === 'PRO') return true
      if (this.$session.user.profile === 'MICRO') return true
      if (this.$session.user.profile === 'FULL') return true

      // busca roles activos del usuario
      const checkRoles = this.$session.user.roles?.filter(role => role.check) || []

      // roles permitidos para COMMUNITY y FACTURA
      if (this.$session.user.profile === 'COMMUNITY' || this.$session.user.profile === 'FACTURA') {
        if (
          path === '/admin/datosatv' ||
          path === '/facturacion/facturar' ||
          path === '/facturacion/listaFactura' ||
          path === '/facturacion/listaTiquete' ||
          path === '/facturacion/listaNotaCredito' ||
          path === '/facturacion/listaFacturaExportacion' ||
          path === '/facturacion/listaMensajeReceptor' ||
          path === '/facturacion/mensajeReceptor' ||
          path === '/facturacion/proforma' ||
          path === '/facturacion/listaFacturaOtro' ||
          path === '/clientes/lista'
        )
          return true

        return false
      }

      const hasRole = this.roles.reduce(
        (acc, role) =>
          checkRoles.some(r => role._id === r._id)
            ? (acc = role.events.reduce(
                (y, event) => (event.group.some(group => group.check && group.path.toUpperCase() === path.toUpperCase()) ? (y = true) : y),
                acc
              ))
            : acc,
        false
      )

      return hasRole
    }
  }
}
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.menu-space {
  margin-bottom: 80px;
}
</style>
